import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 10.754c-3.3 0-6 2.64-6 5.866 0 .586.4.977 1 .977s1-.39 1-.977c0-2.151 1.8-3.91 4-3.91s4 1.759 4 3.91c0 .586.4.977 1 .977s1-.39 1-.977c0-3.226-2.7-5.866-6-5.866m-7.1.293c.2.196.5.294.7.294s.5-.098.7-.294a.93.93 0 0 0 0-1.368L4.9 8.31a.98.98 0 0 0-1.4 0 .93.93 0 0 0 0 1.369zM1 17.597h2c.6 0 1-.39 1-.977s-.4-.978-1-.978H1c-.6 0-1 .391-1 .978 0 .586.4.977 1 .977m19-.977c0 .586.4.977 1 .977h2c.6 0 1-.39 1-.977s-.4-.978-1-.978h-2c-.6 0-1 .391-1 .978m-1.6-5.28c.3 0 .5-.097.7-.293l1.4-1.368a.93.93 0 0 0 0-1.369.98.98 0 0 0-1.4 0l-1.4 1.369a.93.93 0 0 0 0 1.368c.1.196.4.294.7.294zm4.6 8.212H1c-.6 0-1 .391-1 .978s.4.978 1 .978h22c.6 0 1-.392 1-.978 0-.587-.4-.978-1-.978M11.3 8.506c.1.097.2.195.3.195.1.098.3.098.4.098s.3 0 .4-.098.2-.098.3-.195l4-3.91a.93.93 0 0 0 0-1.37.98.98 0 0 0-1.4 0L13 5.477v-4.5C13 .391 12.6 0 12 0s-1 .39-1 .977v4.497L8.7 3.227a.98.98 0 0 0-1.4 0 .93.93 0 0 0 0 1.368z"
    }, null, -1)
  ]))]))
}
export default { render: render }